import { ContentChild, Directive, Input } from '@angular/core';
import { AccordianHeaderDirective } from './accordian-header.directive';
import { AccordianContentDirective } from './accordian-content.directive';
import { AccordianTitleDirective } from './accordian-title.directive';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'black-accordian-item',
    standalone: false
})
export class AccordianItemDirective {

  @Input() title = '';
  @Input() disabled = false;

  @ContentChild(AccordianHeaderDirective)
  customHeader!: AccordianHeaderDirective;

  @ContentChild(AccordianContentDirective)
  content!: AccordianContentDirective;

  @ContentChild(AccordianTitleDirective)
  customTitle!: AccordianTitleDirective;

}
